import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["name", "id", "placeholder", "required", "error", "value", "expanded", "onChange", "onClear", "disabled", "appearance", "isLoading", "dataHook"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { SearchIcon } from '@segment/matcha/components/Icons/Brandbook';
import Input from '@segment/matcha/components/Input';
import Loader from '@segment/matcha/components/Loader';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export var SearchBar = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var name = _ref.name,
      id = _ref.id,
      placeholder = _ref.placeholder,
      required = _ref.required,
      error = _ref.error,
      value = _ref.value,
      expanded = _ref.expanded,
      onChange = _ref.onChange,
      onClear = _ref.onClear,
      disabled = _ref.disabled,
      appearance = _ref.appearance,
      isLoading = _ref.isLoading,
      dataHook = _ref.dataHook,
      rest = _objectWithoutProperties(_ref, _excluded);

  return _jsx(Input, _objectSpread({
    type: "search",
    icon: isLoading ? _jsx(Loader, {
      size: "small"
    }) : _jsx(SearchIcon, {}),
    resetable: true,
    name: name,
    id: id,
    placeholder: placeholder,
    required: required,
    disabled: disabled,
    value: value,
    onChange: onChange,
    onClear: onClear,
    appearance: appearance,
    error: error,
    ref: ref,
    expanded: expanded,
    dataHook: dataHook
  }, rest));
});